import { AfterViewInit, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { SearchBaseResponse } from '../../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { PatientJournalRecordViewModel, PatientJournalRequestModel } from '../../../../models/patients';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { PatientDocumentDataService, PermissionsService } from '../../../../services';
import { TcmBaseSearch } from '../../../../modules/tcm-common/base/tcm-base-search';
import { Task } from '../../../../helpers/task';
import { SearchBaseResponse } from '../../../../modules/tcm-core.module/models/search/search-base-response';

@Component({
    selector: 'patient-journal',
    templateUrl: './patient-journal.component.html',
    styleUrls: ['./patient-journal.component.scss'],
    standalone: false
})
export class PatientJournalComponent extends TcmBaseSearch<PatientJournalRequestModel, SearchBaseResponse<PatientJournalRecordViewModel>> implements AfterViewInit {
  private refreshSubscription: Subscription;
  private permissionsSubscription: Subscription;

  canReadAppointment: boolean;
  canReadSaleOrder: boolean;
  canReadNotes: boolean;
  canReadInvoices: boolean;

  @Input() public isPreview: boolean;

  constructor(protected override componentContext: SecureBaseComponentContext,
    protected override route: ActivatedRoute,
    private patientDocumentDataService: PatientDocumentDataService,
    private permissionsService: PermissionsService) {
    super(componentContext, route);

    this.actionName = 'PatientWidget/PatientJournal';

    this.refreshSubscription = this.componentContext.broadcastService
      .getEvents(BroadCastEvents.ClaimUpdated,
        BroadCastEvents.PaymentChanged,
        BroadCastEvents.ClaimCreated,
        BroadCastEvents.NoteChanged,
        BroadCastEvents.SalesOrderChanged)
      .subscribe(() => {
        this.refresh();
      });
  }

  public async onAttachmentClick($event, docId: number) {
    $event.stopPropagation();

    this.patientDocumentDataService.downloadAndDisplayFileAsync(docId);
  }

  override async ngAfterViewInit() {
    await Task.delay(0, this.componentCancellationTokenSource.promise());

    this.permissionsSubscription = this.permissionsService.permissions$.subscribe(x => {
      this.canReadAppointment = this.permissionsService.checkEntityAccess('scheduling', 'appointments')
      this.canReadSaleOrder = this.permissionsService.checkEntityAccess('sales', 'salesOrders');
      this.canReadNotes = this.permissionsService.checkEntityAccess('patients', 'patientNotes');
      this.canReadInvoices = this.permissionsService.checkEntityAccess('billing', 'patientInvoices');
    });

    super.ngAfterViewInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();

    this.refreshSubscription.unsubscribe();

    if (this.permissionsSubscription) {
      this.permissionsSubscription.unsubscribe();
    }
  }
}
